import Vue from "vue"

// Buttons
import BackButton from "@/components/generics/buttons/BackButton.vue"
import CancelButton from "@/components/generics/buttons/CancelButton.vue"
import CreateButton from "@/components/generics/buttons/CreateButton.vue"
import DeleteButton from "@/components/generics/buttons/DeleteButton.vue"
import DownloadButton from "@/components/generics/buttons/DownloadButton.vue"
import DuplicateButton from "@/components/generics/buttons/DuplicateButton.vue"
import EditButton from "@/components/generics/buttons/EditButton.vue"
import GridButton from "@/components/generics/buttons/GridButton.vue"
import EditInfoButton from "@/components/generics/buttons/EditInfoButton.vue"
import ExportButton from "@/components/generics/buttons/ExportButton.vue"
import LeaveButton from "@/components/generics/buttons/LeaveButton.vue"
import SaveButton from "@/components/generics/buttons/SaveButton.vue"
import StepButton from "@/components/generics/buttons/StepButton.vue"
import Tooltip from "@/components/generics/buttons/Tooltip.vue"
import ValidateButton from "@/components/generics/buttons/ValidateButton.vue"
import WebcamButton from "@/components/generics/buttons/WebcamButton.vue"

Vue.component("avs-backButton", BackButton)
Vue.component("avs-createButton", CreateButton)
Vue.component("avs-cancelButton", CancelButton)
Vue.component("avs-deleteButton", DeleteButton)
Vue.component("avs-downloadButton", DownloadButton)
Vue.component("avs-duplicateButton", DuplicateButton)
Vue.component("avs-editButton", EditButton)
Vue.component("avs-gridButton", GridButton)
Vue.component("avs-editInfoButton", EditInfoButton)
Vue.component("avs-exportButton", ExportButton)
Vue.component("avs-leaveButton", LeaveButton)
Vue.component("avs-saveButton", SaveButton)
Vue.component("avs-stepButton", StepButton)
Vue.component("avs-tooltip", Tooltip)
Vue.component("avs-validateButton", ValidateButton)
Vue.component("avs-webcamButton", WebcamButton)

// Dialogs
import DeleteDialog from "@/components/generics/dialogs/DeleteDialog"
import ConfirmDialog from "@/components/generics/dialogs/ConfirmDialog"
import CloseDialog from "@/components/generics/dialogs/CloseDialog"

Vue.component("avs-deleteDialog", DeleteDialog)
Vue.component("avs-confirmDialog", ConfirmDialog)
Vue.component("avs-CloseDialog", CloseDialog)

// General
import Button from "@/components/generics/general/Button.vue"
import Card from "@/components/generics/general/Card.vue"
import Chip from "@/components/generics/general/Chip.vue"
import Switch from "@/components/generics/general/Switch.vue"

Vue.component("avs-button", Button)
Vue.component("avs-card", Card)
Vue.component("avs-chip", Chip)
Vue.component("avs-switch", Switch)

// Role
import Role from "@/components/generics/status/Role.vue"

Vue.component("avs-role", Role)

// Typographies
import Title from "@/components/generics/typographies/Title.vue"
import Subtitle from "@/components/generics/typographies/Subtitle.vue"

Vue.component("avs-title", Title)
Vue.component("avs-subtitle", Subtitle)

export default {}
